import emoji from "react-easy-emoji";

const illustration = {
    animated: false // set to false to use static SVG
};

const greeting = {
    username: "Ashutosh Sameer",
    title: "Hi all, I'm Ashutosh",
    subTitle: emoji(
        "A passionate Full Stack Software Developer having an experience of building Web applications and micro services using AWS / Java / TypeScript / JavaScript / Python."
    ),
    resumeLink:
        "https://drive.google.com/file/d/1ZNBFK8vWqx4m98u5HZShkar0jSHRzQyC/view?usp=sharing",
    displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
    github: "https://github.com/ashutoshsameer",
    linkedin: "https://www.linkedin.com/in/ashutosh-sameer/",
    gmail: "sameerashutosh0201@gmail.com",
    facebook: "https://www.facebook.com/ashusameer21",
    display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
    title: "About Me",
    subTitle: "I am currently a graduate student at Columbia University with the latest past experience at Amazon as a Software Development Engineer Intern with their Paid Search Team from June 2022 to Sept 2022.",
    skills: [
        emoji(
            "⚡ Designed and implemented a solution for syncing millions of bids daily across search engines to promote Amazon Ads"
        ),
        emoji("⚡ Migrated on-premise bid-sync jobs to a pub-sub based model running in containerized AWS Batch jobs using SNS"),
        emoji(
            "⚡ Improved overall process runtime by 75% and improved robustness by automating creation of jobs and infrastructure interactions using AWS CDK"
        )
    ],

    /* Make Sure to include correct Font Awesome Classname to view your icon
  https://fontawesome.com/icons?d=gallery */

    softwareSkills: [
        {
            skillName: "Java",
            fontAwesomeClassname: "fab fa-java"
        },
        {
            skillName: "AWS",
            fontAwesomeClassname: "fab fa-aws"
        },
        {
            skillName: "JavaScript",
            fontAwesomeClassname: "fab fa-js"
        },
        {
            skillName: "reactjs",
            fontAwesomeClassname: "fab fa-react"
        },
        {
            skillName: "sql and nosql database",
            fontAwesomeClassname: "fas fa-database"
        },
        {
            skillName: "python",
            fontAwesomeClassname: "fab fa-python"
        },
        {
            skillName: "docker",
            fontAwesomeClassname: "fab fa-docker"
        }
    ],
    display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
    display: true, // Set false to hide this section, defaults to true
    schools: [
        {
            schoolName: "Columbia University",
            logo: require("./assets/images/img.png"),
            subHeader: "Master of Science in Computer Science",
            duration: "September 2021 - December 2022",
            desc: "Machine Learning Track",
            descBullets: [
                "GPA - 4.0/4.0",
                "Relevant Courses: Analysis of Algorithms, Artificial Intelligence, Introduction to Databases, Cloud Computing and Big Data, Applied Machine Learning, NLP, Computer Vision - II, Advanced Database Systems / Information Retrieval",
//        "Tech Team Head at Spring Fest, IIT Kharagpur where I mentored 350+ students and spearheaded a team of 12 subheads which moved the fest towards digitized way of working from paper for the first time"
            ]
        },
        {
            schoolName: "IIT Kharagpur",
            logo: require("./assets/images/IIT_Kharagpur_Logo.jpeg"),
            subHeader: "Bachelor of Technology in Mechanical Engineering with minor in Computer Science",
            duration: "August 2015 - April 2019",
            desc: "Ranked top 5% in the program.",
            descBullets: [
                "Secured 9.26/10 CGPA at the end of my bachelors",
                "Tech Team Head at Spring Fest, IIT Kharagpur where I mentored 350+ students and spearheaded a team of 12 subheads which moved the fest towards digitized way of working from paper for the first time"
            ]
        }
    ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
    viewSkillBars: false, //Set it to true to show Proficiency Section
    experience: [
        {
            Stack: "Frontend/Design", //Insert stack or technology you have experience in
            progressPercentage: "90%" //Insert relative proficiency in percentage
        },
        {
            Stack: "Backend",
            progressPercentage: "70%"
        },
        {
            Stack: "Programming",
            progressPercentage: "60%"
        }
    ],
    displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
    display: true, //Set it to true to show workExperiences Section
    experience: [
        {
            role: "Software Dev Engineer Intern",
            company: "Amazon",
            companylogo: require("./assets/images/Amazon-Thumbnail.png"),
            date: "June 2022 – September 2022",
            desc: "Tech Stack - Java, TypeScript, AWS Services",
            descBullets: [
                "Designed and implemented a solution for syncing millions of bids daily across search engines to promote Amazon Ads",
                "Migrated on-premise bid-sync jobs to a pub-sub based model running in containerized AWS Batch jobs using SNS",
                "Improved overall process runtime by 75% and automated creation of jobs and infrastructure interactions using AWS CDK"
            ]
        },
        {
            role: "Software Development Engineer",
            company: "Goldman Sachs",
            companylogo: require("./assets/images/Shape-Goldman-Sachs-Logo.png"),
            date: "June 2019 – August 2021",
            desc: "Tech Stack - Java, ReactJs, SQL, Python",
            descBullets: [
                "Created a service for auto generating email to be sent to the client and based on their response, classify the intent and ingest the information in the parent system",
                "Automated the process of gathering client data while onboarding of clients by downloading publicly client documents through web scraping which improved the latency of 50 mins to 5 mins",
                "Uplifted existing deployment infrastructure to use Kubernetes (k8s) and Docker Containers",
                "The system built saved $2.5M by automating the work of 40 headcounts"
            ]
        },
        {
            role: "Software Development Engineer Intern",
            company: "Morgan Stanley",
            companylogo: require("./assets/images/ms_logo.jpeg"),
            date: "May 2018 – July 2018",
            desc: "Tech Stack - Java, AngularJs, SQL",
            descBullets: [
                "Developed a platform with graphical components for the consolidated view of the Financial Reference Data using Angular",
                "Created a RESTful Web Service API using Spring Boot in Java and wrote stored procedures in SYBASE to be consumed by the Service layer",
                "Implemented Ehcache for the caching of global data in the Web Service Layer and added searching feature for the same on the UI."
            ]
        },
        {
            role: "Full Stack Developer Intern",
            company: "Greetude Energy",
            companylogo: require("./assets/images/greetude.png"),
            date: "May 2017 – July 2017",
            desc: "Tech Stack - PHP, SQL, HTML, CSS (Bootstrap, Materialize)",
            descBullets: [
                "Developed a portal which took specifications of a device and gave an output of a better replacement for the same using PHP(MVC architecture) and MySQL database",
                "Designed a platform for students enrolled to see their periodic test reports and lost marks analysis",
                "Created an online Expense Management system using different Web technologies and PHP"
            ]
        }
    ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
    showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
    display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
    title: "Big Projects",
    subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
    projects: [
        {
            image: require("./assets/images/saayaHealthLogo.webp"),
            projectName: "Saayahealth",
            projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
            footerLink: [
                {
                    name: "Visit Website",
                    url: "http://saayahealth.com/"
                }
                //  you can add extra buttons here.
            ]
        },
        {
            image: require("./assets/images/nextuLogo.webp"),
            projectName: "Nextu",
            projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
            footerLink: [
                {
                    name: "Visit Website",
                    url: "http://nextu.se/"
                }
            ]
        }
    ],
    display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
    title: emoji("Achievements And Certifications 🏆 "),
    subtitle:
        "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

    achievementsCards: [
        {
            title: "Google Code-In Finalist",
            subtitle:
                "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
            image: require("./assets/images/codeInLogo.webp"),
            footerLink: [
                {
                    name: "Certification",
                    url:
                        "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
                },
                {
                    name: "Award Letter",
                    url:
                        "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
                },
                {
                    name: "Google Code-in Blog",
                    url:
                        "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
                }
            ]
        },
        {
            title: "Google Assistant Action",
            subtitle:
                "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
            image: require("./assets/images/googleAssistantLogo.webp"),
            footerLink: [
                {
                    name: "View Google Assistant Action",
                    url:
                        "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
                }
            ]
        },

        {
            title: "PWA Web App Developer",
            subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
            image: require("./assets/images/pwaLogo.webp"),
            footerLink: [
                {name: "Certification", url: ""},
                {
                    name: "Final Project",
                    url: "https://pakistan-olx-1.firebaseapp.com/"
                }
            ]
        }
    ],
    display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
    title: "Blogs",
    subtitle:
        "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",

    blogs: [
        {
            url:
                "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
            title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
            description:
                "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
        },
        {
            url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
            title: "Why REACT is The Best?",
            description:
                "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
        }
    ],
    display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
    title: "TALKS",
    subtitle: emoji(
        "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
    ),

    talks: [
        {
            title: "Build Actions For Google Assistant",
            subtitle: "Codelab at GDG DevFest Karachi 2019",
            slides_url: "https://bit.ly/saadpasta-slides",
            event_url: "https://www.facebook.com/events/2339906106275053/"
        }
    ],
    display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
    title: emoji("Podcast 🎙️"),
    subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

    // Please Provide with Your Podcast embeded Link
    podcast: [
        "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
    ],
    display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
    title: emoji("Contact Me ☎️"),
    subtitle:
        "Discuss a project or just want to say hi? My Inbox is open for all.",
    number: "+1 (917) 603-5136",
    email_address: "as6416@columbia.edu",
};

// Twitter Section

const twitterDetails = {
    userName: "twitter", //Replace "twitter" with your twitter username without @
    display: true // Set true to display this section, defaults to false
};

export {
    illustration,
    greeting,
    socialMediaLinks,
    skillsSection,
    educationInfo,
    techStack,
    workExperiences,
    openSource,
    bigProjects,
    achievementSection,
    blogSection,
    talkSection,
    podcastSection,
    contactInfo,
    twitterDetails
};
